<template>
  <div class="signature-container">
    <canvas ref="signatureCanvas" width="400" height="200" class="signature-canvas"></canvas>
     <!-- Mensaje de alerta -->
      <!-- Alerta modal y flotante -->
    <v-overlay v-if="showAlert" opacity="0.7" :value="showAlert" @click="showAlert = false">
      <v-alert
        type="error"
        border="left"
        prominent
        class="modal-alert"
        dismissible
        @input="showAlert = false"
      >
        {{ alertMessage }}
      </v-alert>
    </v-overlay>
    Signatario: 
    <v-text-field
      v-model="signatario"
      label="Nombre"
      placeholder="Nombre signatario"
      outlined
      clearable
    />
    
    <div class="button-container">
      <button @click="clearSignature" class="button">Limpiar</button>
      <button @click="saveSignature" class="button">Guardar</button>
    </div>

   

   
  </div>
</template>

<script>
import SignaturePad from 'signature_pad';

export default {
  data() {
    return {
      signaturePad: null,
      signatario: null,
      showAlert: false,
      alertMessage: ""
    };
  },
  props: {
    name: String
  },
  mounted() {
    this.signaturePad = new SignaturePad(this.$refs.signatureCanvas);
  },
  methods: {
    clearSignature() {
      this.signaturePad.clear();
    },
    saveSignature() {
      if (!this.signatario) {
        this.alertMessage = "Por favor, ingresa el nombre del signatario antes de guardar.";
        this.showAlert = true;
        return;
      }

      if (this.signaturePad.isEmpty()) {
        this.alertMessage = "Por favor, firma en el cuadro antes de guardar.";
        this.showAlert = true;
        return;
      }

      const dataURL = this.signaturePad.toDataURL("image/png");
      const byteString = atob(dataURL.split(',')[1]);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uintArray = new Uint8Array(arrayBuffer);

      for (let i = 0; i < byteString.length; i++) {
        uintArray[i] = byteString.charCodeAt(i);
      }

      const blob = new Blob([uintArray], { type: 'image/png' });
      const formData = new FormData();

      formData.append("firma", blob, `${this.name || 'firma'}.png`);
      formData.append("signatario", this.signatario);

      this.$emit('guardar', formData);
    }
  }
};
</script>


<style scoped>
.signature-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 5px;
}

.signature-canvas {
  border: 3px solid #007bff; /* Borde visible azul */
  background-color: #f7f7f7; /* Fondo claro */
  cursor: pointer; /* Cursor de puntero */
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2); /* Sombra suave para dar un efecto de "destacar" */
  margin-bottom: 20px; /* Espacio debajo del canvas */
  transition: box-shadow 0.2s ease-in-out; /* Transición suave para el efecto de hover */
}

.signature-canvas:hover {
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.5); /* Aumentar la sombra al pasar el mouse */
}

.button-container {
  display: flex;
  justify-content: space-around;
  width: 100%;
  max-width: 400px;
}

.button {
  background-color: #007bff;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: 45%;
}

.button:hover {
  background-color: #0056b3;
}
</style>
